<template>
  <div>
    <div class="panel-toolbar bb-1 d-flex ">
      <plugin-site-nav v-if="isMobile" />
      <h5 class="text-steel">
        Customer</h5>
    </div>
    <div class="panel-action-bar bb-1" v-if='searchMode'>
      <form @submit.prevent="submitSearch()">
        <div class="input-icon-right">
          <input class="form-control" type="text" placeholder="Phone or Email" v-model='dbSearchText' />
          <i v-if='!listLoading && dbSearchText.length == 0' class="fa fa-search"></i>
          <i v-if='listLoading' class='fa fa-spinner fa-pulse'></i>
          <i v-if='!listLoading && dbSearchText.length > 0' class='fa fa-times' @click='dbSearchText = ""'></i>
        </div>
      </form>
    </div>
    <div class="panel-action-bar bb-1" v-if='reportMode && !searchMode'>
      <label class='label-control'>
        Store:
      </label>
      <select class='form-control' v-model='selectedPlatform' @change='storeChanged($event)'>
          <option v-for='store in allowedStores' :key='store.AccountPlatformID' :value='store.AccountPlatformID'>{{store.Name}}</option>
      </select>
    </div>

    <div class="panel-body">
      <!-- Recently Viewed Customer List -->
      <table v-if='!listLoading' id="customer-list" class="table">
        <tbody>
          <tr :class='{"is-selected": index == selectedCustomer}' v-for='(customer, index) in filteredCustomers' :key='customer.CustomerHeader.CustomerName'
            class='actionable' @click='clickItem(customer.CustomerIds); selectedCustomer = index;'>
            <td class="avatar-example p-2">
              <img src="static/assets/img/SVGIcons/icon-user-circle-blue.svg" />
            </td>
            <td class="p-2 text-primary align-middle">
              <strong>{{customer.CustomerHeader.CustomerName | capitalize}}</strong>
            </td>
            <!-- <td class="p-2 align-middle">
              <div class="px-1 timestamp text-right"><small>12:12 AM</small></div>
            </td> -->
          </tr>
          <tr v-if='customers.length == 0'>
            <td>
              There are no results.
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if='listLoading' style='text-align:center'>
        <i class='fa fa-spinner fa-pulses'></i>
      </div>

    </div>

  </div>

</template>

<script>
  import PluginSiteNav from '@/components/Nav/PluginSiteNav.vue'
  export default {
    name: 'customerList',
    components: {
      PluginSiteNav
    },
    data: function () {
      return {
        contextSearchText: '',
        dbSearchText: '',
        selectedCustomer: 0,
      }
    },
    methods: {
      submitSearch() {
        let vm = this;
        vm.$emit('submitsearch', vm.dbSearchText)
      },
      storeChanged(event){
        let vm = this;
        vm.$emit('storechanged', event.target.value)
        console.log(event.target.value)
      }
    },
    props: ['isMobile', 'clickItem', 'customers', 'searchMode', 'listLoading', 'allowedStores', 'reportMode', 'selectedPlatform'],
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      }
    },
    computed: {
      filteredCustomers: function () {
        let vm = this;
        if (vm.contextSearchText) {
          if (vm.contextSearchText.length > 0) {
            let rtnList = []
            vm.customers.forEach(function (element) {
              if (element.CustomerHeader.CustomerName.toLowerCase().indexOf(vm.contextSearchText.toLowerCase()) >
                -1) {
                rtnList.push(element)
              }
            })
            return rtnList;
          } else {
            return vm.customers
          }
        } else {
          return vm.customers
        }

      }
    }
  }

</script>

<style lang='scss' scoped>
  @import '../../../styles/_panels.scss';
  .avatar-example {
    width: 60px;
    img {
      width: 100%;
    }

  }

  #customer-list {
    t-body {
      tr {

        td {}
      }
    }

  }

  .is-selected {
          background-color: $gray-lt;
        }

</style>



// WEBPACK FOOTER //
// src/components/CustomerList/CustomerList.vue